import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useCollectionDeleteLabelMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (labelId: string) => {
      return await collectionApiClient.deleteLabel(labelId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["collection-labels"] });
    },
    onError: (error) => {
      console.error("Failed to delete label:", error);
    },
  });
};

export default useCollectionDeleteLabelMutation;
